import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const submitExternalSignup = async (payload) => {
  const response = await axios.post(`${API_URL}/external-signup`, payload);
  return response.data;
};
